<template>
  <div
    class="component-i93jfna3"
    :max-columns="
      ['2', '3', '4'].includes(acf.max_columns) ? acf.max_columns : 3
    "
    :mode="$root.mode"
    resmed-component-name="vlog_grid_2/3/4col_icon-line_title_cards"
    :style="{ 'background-color': acf.layout['background-color'] || false }"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-5 text-center">
          <eyebrow-icon
            v-if="acf.eyebrowicon"
            :eyebrowicon="acf.eyebrowicon"
            :align="'center'"
          ></eyebrow-icon>
          <h2
            :class="`-has-eyebrow -eyebrow-color-${
              acf.eyebrowicon && acf.eyebrowicon.color
                ? acf.eyebrowicon.color
                : 'black'
            }`"
            :style="{
              color:
                acf.eyebrowicon && acf.eyebrowicon.color
                  ? acf.eyebrowicon.color
                  : false,
            }"
          >
            {{ acf.headline }}
          </h2>
        </div>
      </div>
      <div class="stage">
        <div class="items">
          <div
            class="item"
            v-for="(video, mIdx) in acf.videos.slice(0, maxVisible)"
          >
            <div class="card" v-bind:modal-video-id="video.video_id">
              <figure class="embed-responsive embed-responsive-16by9">
                <div
                  class="embed-responsive-item poster"
                  :style="{
                    'background-image': `url(${
                      video.poster || brightcovePosterFrameMap[video.video_id]
                    })`,
                  }"
                ></div>
                <transition name="fade">
                  <div
                    @click="presentModal(video.player_id, video.video_id)"
                    class="play-button"
                  ></div>
                </transition>
              </figure>
              <div class="content">
                <h3 @click="presentModal(video.player_id, video.video_id)">
                  {{ video.title }}
                </h3>
                <ratings
                  v-bind:type="'video'"
                  v-bind:id="video.video_id"
                ></ratings>
                <hr />
                <div class="content-footer">
                  <div class="tags-container" v-if="video.tags.length">
                    <img src="@/assets/images/icon-coupon-tag.svg" />
                    <span class="tags">{{ video.tags.join(" | ") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-4" v-if="shouldShowLoadMoreButton">
          <button
            class="btn cta-pill hallow-red"
            type="button"
            @click="loadMoreResults(20)"
          >
            Load More&nbsp;&nbsp;&plus;
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "component-i93jfna3", // vlog_grid_2/3/4col_icon-line_title_cards
  props: ["acf"],
  data() {
    return {
      ids: this.acf.videos.map((v) => v.video_id),
      maxVisible: (this.acf.max_columns || 3) * 2,
      brightcovePosterFrameMap: {},
    };
  },
  computed: {
    shouldShowLoadMoreButton() {
      return this.maxVisible < this.acf.videos.length;
    },
  },
  methods: {
    loadMoreResults(numToLoad) {
      this.maxVisible += numToLoad;
    },
    refreshPosterFrames() {
      this.acf.videos.forEach((v) => {
        axios
          .get(
            `//${location.hostname}/wp-json/resmed/v1/brightcove-thumbnail/${v.video_id}`
          )
          .then((response) => {
            this.brightcovePosterFrameMap = {
              ...this.brightcovePosterFrameMap,
              [v.video_id]: response.data.poster.src,
            };
          });
      });
    },
    presentModal(player, videoId) {
      bus.$emit("overlay:active", {
        player: player,
        id: videoId,
        active: true,
      });
    },
  },
  created() {
    this.refreshPosterFrames();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/abstracts/animations";

.component-i93jfna3 {
  background: $cc-resmed-grey-15;
  padding-top: 5rem;
  padding-bottom: 5rem;

  h1,
  h2 {
    &.-has-eyebrow {
      position: relative;
      @extend %eyebrow-center;

      &.-eyebrow-color-white {
        &::before {
          background-color: white;
        }
      }
    }
  }

  &[max-columns="2"] {
    .items {
      .item {
        width: calc(100% / 2);
      }
    }
  }

  &[max-columns="3"] {
    .items {
      .item {
        width: 33.33%;
      }
    }
  }

  &[max-columns="4"] {
    .items {
      .item {
        width: 25%;

        .card {
          .content {
            h3 {
              flex: 1 0 5rem;
              margin-bottom: 0;
            }
          }
        }
      }
    }

    &[mode="md"] {
      .items {
        padding: 0 4rem;

        .item {
          width: 50%;
        }
      }
    }
  }

  &[mode="xs"],
  &[mode="sm"] {
    padding-left: 2rem;
    padding-right: 2rem;

    .items {
      .item {
        width: 100%;
      }
    }
  }

  &[mode="md"] {
    .items {
      .item {
        width: 50%;
      }
    }
  }

  .items {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.5rem;
    margin-right: -0.5rem;

    .item {
      width: 33.33%;
      padding: 0.5rem;
      display: flex;

      .card {
        background: white;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        width: 100%;

        &:hover {
          h3 {
            cursor: pointer;
            color: $cc-resmed-pulse-blue;
          }
        }

        hr {
          border-color: rgba($cc-resmed-grey-30, 0.75);
        }

        figure {
          border-radius: 4px 4px 0 0;
          cursor: pointer;

          .poster {
            background-size: cover;
            background-color: $cc-resmed-black;
          }

          .play-button {
            content: "";
            position: absolute;
            width: 100%;
            padding-top: 56.25%;
            z-index: 3;
            top: 0;
            background-image: url("#{$assets}/images/icon-play-button.svg");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 4rem 4rem;
            opacity: 0.925;
            transition: opacity 0.5s ease;
          }

          &:hover {
            .play-button {
              opacity: 1;
            }
          }
        }

        .content {
          padding: 1.5rem 2rem;
          display: flex;
          flex-direction: column;

          h3 {
            flex: 1 0 4rem;
            font-size: 1.125em;
          }

          .content-footer {
            display: flex;
            align-items: flex-start;

            .tags-container {
              display: flex;
              align-items: flex-start;
              flex: 1 1 auto;

              img {
                margin-top: 4px;
              }

              .tags {
                font-size: 0.75em;
                font-family: "Plus Jakarta Sans", sans-serif;
                font-weight: 700;
                flex: 1 1 auto;
                padding: 0 1rem;
                line-height: 1.29;
              }
            }
          }
        }
      }
    }
  }
}
</style>